import { PARAM_LIST_SEPARATOR, MULTISTOP_IATA_LIST_SEPARATOR, URL_IATA_LIST_SEPARATOR, LOCATION_IATA_CODE_AND_TYPE_SEPARATOR, MANDATORY_SEARCH_PARAMS_ONEWAY, MANDATORY_SEARCH_PARAMS_ROUNDTRIP, MANDATORY_SEARCH_PARAMS_MULTISTOP, VALID_TRIP_TYPES, VALID_CABIN_CLASSES } from "./params.js";
export * from "./features.js";
export * from "./experiments.js";
export * from "./marketing-tracking.js";
export const DEFAULT_LOCALE = "en-gb";
export const CRC_DEFAULT_LANGUAGE = "en-GB";
export const X_BOOKING_TOPIC_HEADER = "X-Booking-Topic";
export const X_BOOKING_ORIGINAL_CLIENT_ID_HEADER = "X-Booking-Original-Client-Id";
export const ENVOY_URL = "http://127.0.0.1:9211";
export const X_BOOKING_FLIGHTS_CLIENT_HINTS = "X-Booking-Flights-Client-Hints";
export const FLIGHTS_CLIENT_HINTS_FEATURES = ["price_change_v2"];
export const XCALL_BOOKING_REQUEST_ID = "request_id";
export const XCALL_BOOKING_PARENT_REQUEST_ID = "parent_request_id";
export const XCALL_BOOKING_REQUEST_TREE_ID = "request_tree_id";
export const RTL_LANGUAGES = ["ar", "he"];
export const DEFAULT_SUPPLIER = "ETG";
export const WEBVIEW_AFFILIATE_IDS_ANDROID = {
    338019: "android-debug",
    337862: "android-production",
    911061: "huawei",
    911062: "huawei",
    911063: "huawei",
    911064: "huawei",
    911065: "huawei",
    911066: "huawei",
    911067: "huawei",
    911068: "huawei",
    1295056: "huawei",
    1514475: "huawei",
    1433611: "huawei",
    1488605: "huawei",
    1488606: "huawei",
    1488607: "huawei",
    1488611: "huawei",
    1488613: "huawei",
    1488614: "huawei",
    1488615: "huawei",
    1488616: "huawei",
    1524737: "huawei",
    1664197: "huawei",
    1613134: "huawei",
    1613118: "huawei",
    1911922: "huawei",
    1926618: "huawei",
    1190801: "xiaomi",
    1355643: "xiaomi",
    1441263: "xiaomi",
    1647594: "xiaomi",
    1647678: "xiaomi",
    1253366: "sfr",
    1200544: "telecom_italia",
    1237832: "sony_mobile",
    1554019: "sony_mobile",
    376323: "acer",
    378919: "acer",
    1180914: "acer",
    1518130: "samsung_africa",
    1518533: "samsung_africa",
    1518534: "samsung_africa",
    1518536: "samsung_africa",
    1518538: "samsung_africa",
    1518540: "samsung_africa",
    1518542: "samsung_africa",
    1518543: "samsung_africa",
    1518546: "samsung_africa",
    1518548: "samsung_africa",
    1518549: "samsung_africa",
    1650850: "samsung_china",
    1908031: "samsung_china",
    1653279: "samsung_gulf",
    1708168: "samsung_brazil",
    1557215: "telecom_italia",
    1588965: "telefonica",
    1647238: "telefonica",
    1653178: "oppo_china",
    1654971: "meo",
    1237790: "p4",
    1237797: "polkomtel",
    1696059: "wiko",
    1699791: "play_pl",
    1674138: "vivo",
    1748961: "bouygues_telecom",
    1773023: "samsung_india",
    1810236: "lg",
    386457: "prestigio",
    1831078: "lg_europe",
    1831080: "lg_mea",
    1831081: "lg_asia",
    1831082: "lg_latin",
    1831083: "lg_korea",
    1831084: "lg_japan",
    1831086: "lg_india",
    1831087: "lg_cis",
    1843168: "telefonica",
    1775508: "orange",
    1874854: "tcl",
    1887228: "xiaomi",
    1926170: "samsung",
    1943837: "xiaomi"
};
export const WEBVIEW_AFFILIATE_IDS_IOS = {
    336317: "Production Ipad",
    332731: "Production Iphone",
    336318: "Test Env Ipad",
    331867: "Test Env Iphone"
};
export const WEBVIEW_AFFILIATE_IDS = {
    ...WEBVIEW_AFFILIATE_IDS_IOS,
    ...WEBVIEW_AFFILIATE_IDS_ANDROID
};
export const GRAPHITE_CLIENT_METRICS_NAMESPACE = "flights.frontend_client";
export const ORDER_TOKEN_VALIDITY = 86400;
export { PARAM_LIST_SEPARATOR, MULTISTOP_IATA_LIST_SEPARATOR, URL_IATA_LIST_SEPARATOR, LOCATION_IATA_CODE_AND_TYPE_SEPARATOR, MANDATORY_SEARCH_PARAMS_ONEWAY, MANDATORY_SEARCH_PARAMS_ROUNDTRIP, MANDATORY_SEARCH_PARAMS_MULTISTOP, VALID_TRIP_TYPES, VALID_CABIN_CLASSES };
export const SPACER = "·";
export const SPACER_PADDED = ` ${SPACER} `;
export const DASH_SPACER = "-";
export const DASH_SPACER_PADDED = ` ${DASH_SPACER} `;
export * from "./routes.js";
export const ANYWHERE = "Anywhere";
export const COMPANY_NAME = "Booking.com";
export const IMAGE_STATIC_ASSETS_URL = "https://q-xx.bstatic.com";
export const PLATFORM_ENV = process.env.PLATFORM_ENV;
export const STAGING_HOSTNAME = "flights-staging.prod.booking.com";
export const PAYMENT_COMPONENT_COOKIE_ID = PLATFORM_ENV === "prod" ? "pc_payer_id" : "dqs_pc_payer_id";
export const HELP_CENTER_URL = "https://secure.booking.com/help";
export const FLIGHTS_BASE_URL = (req) => {
    if (!req)
        return;
    if (process.env.NODE_ENV === "development") {
        const protocol = Boolean(process.env.ENABLE_SSL) ? "https" : "http";
        return `${protocol}://${req.hostname}:${Number(process.env.PORT)}`;
    }
    switch (PLATFORM_ENV) {
        case "prod":
            return req.hostname === STAGING_HOSTNAME ? `https://${STAGING_HOSTNAME}` : "https://flights.booking.com";
        case "dqs":
            return "https://flights.dqs.booking.com";
        default:
            return `https://${req.hostname}`;
    }
};
export const FLIGHTS_OAUTH_CALLBACK_BASE_URL = (req) => `${FLIGHTS_BASE_URL(req)}/api/oauth`;
export const ACCOUNTS_PORTAL_CALLBACK_PATH = (req) => {
    return FLIGHTS_OAUTH_CALLBACK_BASE_URL(req) + "/callback/v3";
};
export const LEGAL_LINKED_TRAVEL_ARRANGEMENT_COUNTRIES = [
    "at",
    "be",
    "bg",
    "ch",
    "cy",
    "cz",
    "de",
    "dk",
    "ee",
    "es",
    "fi",
    "fr",
    "gb",
    "gr",
    "hr",
    "hu",
    "ie",
    "is",
    "it",
    "li",
    "lt",
    "lu",
    "lv",
    "mt",
    "nl",
    "no",
    "pl",
    "pt",
    "ro",
    "se",
    "si",
    "sk"
];
export const ORDER_CONSISTENCY_TRANSFORM = {
    CONSISTENT: "CONSISTENT",
    INCONSISTENT: "INCONSISTENT"
};
export const CO2E_EMISSIONS_HC_LINK = `${HELP_CENTER_URL}/faq/40/RmxpZ2h0cyAtIEZBUXMgLSBDTzIgMTA5ODcw?category=flights_faq_topic_booking&render_html=1`;
export const COUNTRY_REGION_RESTRICTION = {
    cu: { all: true, regions: [] },
    ir: { all: true, regions: [] },
    kp: { all: true, regions: [] },
    sy: { all: true, regions: [] },
    az: { all: false, regions: ["nagorno", "karabakh"] },
    ge: { all: false, regions: ["abkhazia", "ossetia"] },
    ua: {
        all: false,
        regions: ["kherson", "zaporizhzhya", "zaporizhya", "zaporozhe", "zaporozhye", "crimea", "donetsk", "luhansk"]
    }
};
export const INSTALLMENTS_FAQ_URL = `${HELP_CENTER_URL}/faqs_list/40/flights-faq-topic-payment`;
export const EEA_COUNTRY_CODE_LIST = [
    "at",
    "be",
    "bg",
    "cy",
    "cz",
    "de",
    "dk",
    "ee",
    "el",
    "es",
    "fi",
    "fr",
    "hr",
    "hu",
    "ie",
    "is",
    "it",
    "li",
    "lt",
    "lu",
    "lv",
    "mt",
    "nl",
    "no",
    "pl",
    "pt",
    "ro",
    "se",
    "si",
    "sk"
];
export const UCW_EEA_COUNTRY_CODE_LIST = [
    "at",
    "be",
    "cy",
    "cz",
    "de",
    "dk",
    "ee",
    "es",
    "fi",
    "fr",
    "gr",
    "hu",
    "ie",
    "is",
    "it",
    "lu",
    "mt",
    "nl",
    "no",
    "pl",
    "pt",
    "ro",
    "se"
];
export const BOOKING_DEFAULT_AFFILIATE_ID = "304142";
export const BOOKING_DEFAULT_LABEL = "";
export const FLIGHTS_DEFAULT_LABEL = "flights-booking-direct";
export const FLIGHTS_UNKNOWN_LABEL = "flights-booking-unknown";
export const X_BOOKING_FLIGHTS_WIREMOCK = "X-Booking-Flights-WireMock";
export const MOCK_SCENARIO_ENABLED = "mock-scenario-enabled";
export const MOCK_SCENARIO_NAME = "mock-scenario-name";
export const X_BOOKING_RESEND_CONFIRMATION_EMAIL_REFERRER = "X-Booking-Resend-Confirmation-Email-Referrer";
export const X_BOOKING_DISTRIBUTION_ID = "X-Booking-Distribution-Id";
export const X_FLIGHTS_USE_CASE = "X-Flights-Use-Case";
export const X_FLIGHTS_AWS_WAF_INTEGRATION = "X-Flights-Aws-Waf-Integration";
export const INFANT_MAX_AGE = 1;
export const KID_MAX_AGE = 17;
export const ADULT_ESTIMATED_MIN_AGE = 12;
export const ADULT_ESTIMATED_MIN_AGE_SKYSCANNER = 16;
export const SEARCH_PAGE_SIZE = 15;
export const SEARCH_PAGE_SIZE_WEB_MOBILE = 25;
export const SEARCH_PAGE_SIZE_MIN_WEB_DESKTOP = 10;
export const SEARCH_PAGE_SIZE_MAX_WEB_DESKTOP = 20;
export const SESSION_SEARCH_HISTORY_MAX_RESULTS = 3;
export const RECENT_SEARCH_NEEDED_SEARCH_PARAMS_KEYS = [
    "type",
    "adults",
    "cabinClass",
    "children",
    "from",
    "to",
    "fromCountry",
    "toCountry",
    "fromLocationName",
    "toLocationName",
    "depart",
    "return",
    "multiStopDates"
];
export const RECENT_SEARCH_NEEDED_FILTER_PARAMS_KEYS = [
    "stops",
    "airlines",
    "duration",
    "depInt",
    "arrInt",
    "depTimeInt",
    "arrTimeInt",
    "flightTimesResolution",
    "maxBudget",
    "maxBudgetPerAdult",
    "maxDuration",
    "maxLayoverDuration",
    "airports",
    "preferSameAirport",
    "allDeals"
];
export const GRAPHITE_METRIC_AGGREGATION_NAMESPACE = "flights.frontend";
export const GRAPHITE_METRIC_AGGREGATION_NAMESPACE_FUNNEL = "flights.frontend_funnel";
export const GRAPHITE_METRIC_AGGREGATION_NAMESPACE_APP_CLIENTS = "flights.app_clients";
export const GRAPHITE_METRIC_AGGREGATION_NAMESPACE_BLANKING = "flights.frontend_blanking";
export const GRAPHITE_METRIC_AGGREGATION_NAMESPACE_CUSTOMER_ACQUISITION = "flights.customer-acquisition";
export const GRAPHITE_METRIC_AGGREGATION_NAMESPACE_WHITELABEL_USERAGENT = "flights.whitelabel_useragent";
export const GRAPHITE_METRIC_AGGREGATION_NAMESPACE_FLY_ANYWHERE = "flights.frontend_fly_anywhere";
export const GRAPHITE_METRIC_AGGREGATION_NAMESPACE_CURRENCY_SELECTION = "flights.frontend_currency_selection";
export const WORKER_GRAPHITE_METRIC_AGGREGATION_NAMESPACE = "flights.frontend_worker";
export const CRC_NAMESPACE = "crc.headers";
export const GRAPHITE_METRIC_CLINET_SUB_NAMESPACE = "from_client";
export { A11Y_MOBILE_QUERY_PARAMS } from "./params.js";
export const LATAM_COUNTRIES = ["br", "cl", "co", "pe", "mx"];
export const FREE_BOARDER_CROSSING_COUNTRIES_IN_SCHENGEN_AREA = new Set([
    "AT",
    "BE",
    "BG",
    "CH",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IT",
    "LI",
    "LT",
    "LU",
    "LV",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK"
]);
export const FLY_ANYWHERE_DISCLAIMER_NUM_DAYS = 3;
export const SELECTED_CURRENCY_COOKIE_NAME = "explicit_currency_preference";
export const X_FLIGHTS_GATEWAY_UPSTREAM_INFO_HEADER = "X-Flights-Gateway-Upstream-Info";
export * from "./currency.js";
export const TRAFFIC_ATTRIBUTION_ALLOWED_VALUES = ["wishlist", "b4b"];
export const INTERNAL_SNAPSHOT_PARAM = "snapshot";
export const INTERNAL_SNAPSHOT_PASTE_API = "https://paste.booking.com/api";
